// extracted by mini-css-extract-plugin
export default {"grid":"G0921ef"};